/**
 * @generated SignedSource<<3874d855cdc5e424b2e5fe8c5428fa0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OverviewRecommendationsSectionEmptyState_organization$data = {
  readonly name: string;
  readonly visitorIsMember: boolean;
  readonly " $fragmentType": "OverviewRecommendationsSectionEmptyState_organization";
};
export type OverviewRecommendationsSectionEmptyState_organization$key = {
  readonly " $data"?: OverviewRecommendationsSectionEmptyState_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"OverviewRecommendationsSectionEmptyState_organization">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OverviewRecommendationsSectionEmptyState_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorIsMember",
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node as any).hash = "49b83808749e8e1c6ab485d9c1540066";

export default node;
